const mainHost = () => {
  const host = window.location.host;
  const allowedDomains = ['named.com', 'xn--950bo4em5v.co', 'named.net', 'named2.net', 'named2.kr'];

  for (const domain of allowedDomains) {
    if (host.endsWith(domain)) {
      return domain;
    }
  }
  return 'nmd.co';
};

export default mainHost;
